/**
 * Training Management
 * Gestão de treinamentos
 */
import { GraduationCap, Plus, Play, Users, Clock } from 'lucide-react'

const trainingModules = [
  {
    id: '1',
    name: 'NR-35 - Trabalho em Altura',
    category: 'Segurança',
    duration: '4h',
    enrolled: 245,
    completionRate: 78,
    status: 'active',
  },
  {
    id: '2',
    name: 'Uso Correto de EPIs',
    category: 'EPI',
    duration: '2h',
    enrolled: 512,
    completionRate: 92,
    status: 'active',
  },
  {
    id: '3',
    name: 'Postura Ergonômica',
    category: 'Produtividade',
    duration: '1h 30min',
    enrolled: 189,
    completionRate: 65,
    status: 'active',
  },
]

export default function Training() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white">Treinamentos</h1>
          <p className="text-slate-400">Gestão de conteúdos e treinamentos</p>
        </div>
        <button className="btn-admin flex items-center gap-2">
          <Plus className="w-4 h-4" />
          Novo Treinamento
        </button>
      </div>
      
      {/* Stats */}
      <div className="grid grid-cols-4 gap-4">
        <div className="admin-stat">
          <GraduationCap className="w-8 h-8 text-violet-400 mb-3" />
          <p className="text-2xl font-bold text-white">24</p>
          <p className="text-sm text-slate-400">Módulos Ativos</p>
        </div>
        <div className="admin-stat">
          <Users className="w-8 h-8 text-cyan-400 mb-3" />
          <p className="text-2xl font-bold text-white">1,847</p>
          <p className="text-sm text-slate-400">Alunos Inscritos</p>
        </div>
        <div className="admin-stat">
          <Play className="w-8 h-8 text-emerald-400 mb-3" />
          <p className="text-2xl font-bold text-white">78%</p>
          <p className="text-sm text-slate-400">Taxa Conclusão</p>
        </div>
        <div className="admin-stat">
          <Clock className="w-8 h-8 text-amber-400 mb-3" />
          <p className="text-2xl font-bold text-white">45h</p>
          <p className="text-sm text-slate-400">Conteúdo Total</p>
        </div>
      </div>
      
      {/* Modules List */}
      <div className="admin-card">
        <h2 className="text-lg font-semibold text-white mb-4">Módulos de Treinamento</h2>
        <div className="space-y-4">
          {trainingModules.map((module) => (
            <div key={module.id} className="p-4 rounded-xl bg-slate-800/30 border border-slate-700/50 hover:border-violet-500/30 transition-colors">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 rounded-xl bg-violet-500/10 border border-violet-500/20">
                    <GraduationCap className="w-5 h-5 text-violet-400" />
                  </div>
                  <div>
                    <h3 className="font-medium text-white">{module.name}</h3>
                    <p className="text-sm text-slate-400">{module.category} • {module.duration}</p>
                  </div>
                </div>
                <div className="flex items-center gap-6">
                  <div className="text-right">
                    <p className="text-sm font-medium text-white">{module.enrolled} inscritos</p>
                    <p className="text-xs text-emerald-400">{module.completionRate}% conclusão</p>
                  </div>
                  <button className="btn-secondary text-sm">Editar</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

